import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { PlusMembershipType } from '@browsing/plus';

import { fetchCustomerAction } from '../actions';
import { State } from '../state';

const initialState: State['plus'] = {
    member: false,
    status: null,
    type: PlusMembershipType.None,
};

export const reducer = reducerWithInitialState<State['plus']>(initialState).case(
    fetchCustomerAction.done,
    (state, { result }) => {
        const { plus_status: plusStatus } = result;

        return {
            ...state,
            ...plusStatus,
        };
    },
);

export default reducer;
